// controllers/collapse_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "icon"]

    connect() {
        this.expanded = true
    }

    toggle() {
        this.expanded = !this.expanded
        this.contentTarget.classList.toggle("d-none", !this.expanded)
        this.iconTarget.classList.toggle("bi-chevron-up", this.expanded)
        this.iconTarget.classList.toggle("bi-chevron-down", !this.expanded)
    }
}